const capitalize = (str) => {
  if (!str) return;
  return str
    .split(' ')
    .map((sub) => sub[0].toUpperCase() + sub.slice(1)).join(' ')
}

export default capitalize
